import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "invite_a_friend_modal",
  "data-toggle": "modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "invite_a_friend_modal_label"
  }, " Invite a friend "),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Address", -1)
const _hoisted_8 = { class: "fv-plugins-message-container" }
const _hoisted_9 = { class: "fv-help-block" }
const _hoisted_10 = { class: "modal-footer" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Close ", -1)
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Send ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Form, {
          onSubmit: _ctx.handleSubmit,
          "validation-schema": _ctx.validationSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_Field, {
                  type: "text",
                  class: "form-control form-control-solid",
                  placeholder: "Enter email",
                  name: "email",
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_ErrorMessage, { name: "email" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("button", {
                class: "btn btn-primary",
                type: "submit",
                disabled: _ctx.loading
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                  : _createCommentVNode("", true),
                _hoisted_14
              ], 8, _hoisted_12)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ]))
}